@if (actionFlags.edit) {
  <ion-button mode="ios" class="proto-button primary-cta-button"
    fill="outline"
    color="primary"
    size="small"
    [disabled]="isLoading"
    (click)="buttonClicked.emit('edit')">
    <ion-icon name="create-outline" slot="icon-only"></ion-icon>
  </ion-button>
}

@if (actionFlags.clipboard) {
  <ion-button mode="ios" class="proto-button primary-cta-button"
    [fill]="isAuthorized ? 'outline' : 'solid'"
    color="primary"
    size="small"
    [disabled]="isLoading"
    (click)="buttonClicked.emit('clipboard')">
    <ion-icon name="copy-outline" slot="icon-only"></ion-icon>
  </ion-button>
}

@if (actionFlags.export && !isAuthorized) {
  <ion-button mode="ios" class="proto-button primary-cta-button"
    fill="solid"
    color="primary"
    size="small"
    [disabled]="isLoading"
    (click)="buttonClicked.emit('export')">
    <ion-icon name="download-outline" slot="icon-only"></ion-icon>
  </ion-button>
}

@if (isAuthorized) {
  <ion-button class="proto-button"
    [disabled]="isLoading || menuIsDisabled"
    (click)="showMenu($event)">
    <ion-icon name="ellipsis-vertical" slot="icon-only" color="primary"></ion-icon>
  </ion-button>
  <ion-popover #popover mode="md"
    [isOpen]="menuIsActive"
    [dismissOnSelect]="true"
    (didDismiss)="menuIsActive = false">
    <ng-template>
      <ion-content>
        <ion-list>
          @for (menuItem of menuItems; track menuItem.id) {
            <ion-item [button]="true"
              [detail]="false"
              [disabled]="menuItem.isDisabled"
              [skipDialog]="!menuItem.showConfirmDialog"
              (confirm)="onMenuItemClicked(menuItem.id)">
              <ion-icon [name]="menuItem.icon" slot="start" [color]="menuItem.color"></ion-icon>
              <ion-label [color]="menuItem.color">{{ menuItem.label | translate }}</ion-label>
            </ion-item>
          }
        </ion-list>
      </ion-content>
    </ng-template>
  </ion-popover>
}
